(function (ng) {
    

    const ModuleCtrl = function () {
        const ctrl = this;
    };

    angular.module('module').controller('ModuleCtrl', ModuleCtrl);

    ModuleCtrl.$inject = [];
})(window.angular);
